import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalClose() {
  return <section className="bg-[#0A0A0A] py-20 md:py-28" data-id="element-40">
      <div className="max-w-3xl mx-auto px-6" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-42">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#F5F5F0] tracking-tight mb-8 leading-tight" data-id="element-43">
            You've Got Four Options. Only One Makes Sense.
          </h2>

          <p className="text-lg text-[#9CA3AF] leading-relaxed mb-12" data-id="element-44">
            You've been dealing with this long enough that it's affecting you —
            not just your appearance, but your mental bandwidth. The constant
            monitoring. The lighting calculations. The quiet, persistent stress
            of watching something change and feeling like you can't stop it.
          </p>

          <p className="text-lg font-medium text-[#F5F5F0] mb-8" data-id="element-45">
            Here are your options, clearly:
          </p>
        </motion.div>

        {/* Option Cards */}
        <div className="space-y-4 mb-16" data-id="element-46">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: 0
        }} className="bg-[#1A1A1A] border border-[#2A2A2A] rounded-lg p-6" data-id="element-47">
            <div className="flex items-start gap-4" data-id="element-48">
              <span className="text-sm font-bold text-[#4B5563] bg-[#2A2A2A] px-3 py-1 rounded flex-shrink-0" data-id="element-49">
                1
              </span>
              <div data-id="element-50">
                <h4 className="text-lg font-bold text-[#F5F5F0] mb-2" data-id="element-51">
                  Finasteride
                </h4>
                <p className="text-[#9CA3AF] leading-relaxed" data-id="element-52">
                  It works for many men. If you've already decided the
                  side-effect risk isn't a tradeoff you want to make, this
                  option is off the table.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: 0.1
        }} className="bg-[#1A1A1A] border border-[#2A2A2A] rounded-lg p-6" data-id="element-53">
            <div className="flex items-start gap-4" data-id="element-54">
              <span className="text-sm font-bold text-[#4B5563] bg-[#2A2A2A] px-3 py-1 rounded flex-shrink-0" data-id="element-55">
                2
              </span>
              <div data-id="element-56">
                <h4 className="text-lg font-bold text-[#F5F5F0] mb-2" data-id="element-57">
                  Hair Transplant
                </h4>
                <p className="text-[#9CA3AF] leading-relaxed" data-id="element-58">
                  $10,000–$30,000. Finite donor supply. Ongoing maintenance
                  still required. Not where you are right now.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: 0.2
        }} className="bg-[#1A1A1A] border border-[#2A2A2A] rounded-lg p-6" data-id="element-59">
            <div className="flex items-start gap-4" data-id="element-60">
              <span className="text-sm font-bold text-[#4B5563] bg-[#2A2A2A] px-3 py-1 rounded flex-shrink-0" data-id="element-61">
                3
              </span>
              <div data-id="element-62">
                <h4 className="text-lg font-bold text-[#F5F5F0] mb-2" data-id="element-63">
                  Do Nothing
                </h4>
                <p className="text-[#9CA3AF] leading-relaxed" data-id="element-64">
                  The window narrows every month. This option has a guaranteed
                  outcome, and it isn't the one you want.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: 0.3
        }} className="bg-[#1A1A1A] border-2 border-[#C8A04A] rounded-lg p-6" data-id="element-65">
            <div className="flex items-start gap-4" data-id="element-66">
              <span className="text-sm font-bold text-[#C8A04A] bg-[#C8A04A]/10 px-3 py-1 rounded flex-shrink-0" data-id="element-67">
                4
              </span>
              <div data-id="element-68">
                <h4 className="text-lg font-bold text-[#C8A04A] mb-2" data-id="element-69">
                  CrownControl™
                </h4>
                <p className="text-[#9CA3AF] leading-relaxed" data-id="element-70">
                  Non-hormonal. FDA-cleared device class. Clinically documented
                  mechanism. 10 minutes a day. $497 with a 180-day guarantee.
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Close + CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center" data-id="element-71">
          <p className="text-xl font-bold text-[#F5F5F0] mb-2" data-id="element-72">
            The controlled middle path. The only option that lets you act
            without compromise.
          </p>
          <p className="text-lg text-[#C8A04A] font-medium mb-10" data-id="element-73">
            Take Control Before It's Too Late.
          </p>

          <CTAButton className="mb-8" data-id="element-74" />

          <p className="text-[#9CA3AF] mb-6" data-id="element-75">
            $497 · 180-Day Guarantee · Free Shipping
          </p>

          <CTAButton text="ORDER CROWNCONTROL™ — $497" subtitle="Order risk-free. 180 days to see results." data-id="element-76" />
        </motion.div>
      </div>
    </section>;
}